<template>
  <div>
    <Loader :loading="loading" no-axios>
      <div v-if="!loading" class="d-flex flex-column gap-2">
        <b-form-group :label="`Status`" class="row" label-cols-md="12" label-class="pt-0 pb-4px body-font-sm">
          <!-- <b-dropdown class="card-drop" toggle-class="p-0" menu-class="dropdown-menu-end" variant="link">
            <template v-slot:button-content>
              <div :class="['badge rounded-pill', badgeClass(value.distress_status)]">
                {{ $t("customer_account_receivables.distress_statuses." + value.distress_status) }}
                <i class="mdi mdi-chevron-down"></i>
              </div>
            </template>
            <slot name="action" v-bind="{ data }">
              <b-dropdown-item
                v-for="status in statuses"
                :key="status"
                @click="$emit('distress-status-selected', value, status)"
              >
                <div :class="['badge rounded-pill', badgeClass(status)]">
                  {{ $t("customer_account_receivables.distress_statuses." + status) }}
                </div>
              </b-dropdown-item>
            </slot>
          </b-dropdown> -->
          <DistressStatus :item="value" @updated="$emit('updated', $event)" />
        </b-form-group>
        <b-form-group :label="`Respon Terakhir`" class="row" label-cols-md="12" label-class="pt-0 pb-4px body-font-sm">
          <div class="d-flex justify-content-between gap-16px">
            <b-textarea
              v-if="editing"
              v-model="model.description"
              :rows="3"
              :max-rows="3"
              :disabled="loading"
              placeholder="Catatan"
              class="form-control"
            ></b-textarea>
            <span v-else style="white-space: pre-wrap;">{{ model.description || "-" }}</span>
            <div>
              <b-button v-if="!editing" @click="editing = true" variant="primary">
                <span>Edit</span>
              </b-button>
              <b-button :disabled="updating" v-else @click="handleUpdate" variant="success">
                <i v-if="updating" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                <span>Simpan</span>
              </b-button>
            </div>
          </div>
        </b-form-group>
        <sale-orders v-model="value"></sale-orders>
      </div>
    </Loader>
  </div>
</template>

<script>
import Loader from "@/components/widgets/loader";
import editable from "@/components/mixins/editable";
import DistressStatus from "./distress_status";
import SaleOrders from "./sale_orders";
export default {
  components: {
    Loader,
    DistressStatus,
    SaleOrders
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [editable],
  data() {
    return {
      statuses: ["healthy", "first_warning", "second_warning", "discontinue"],
      items: [],
      loading: false,
      editing: false,
      model: null
    };
  },
  mounted() {
    this.fetchModel();
  },
  methods: {
    badgeClass(distress_status) {
      const status = {
        healthy: "badge-soft-green-500",
        first_warning: "badge-soft-yellow-500",
        second_warning: "badge-soft-orange-500",
        discontinue: "badge-soft-red-500"
      };
      return status[distress_status];
    },
    fetchModel() {
      this.loading = true;
      this.$axios
        .get(`/customer_finance_accounts/${this.value.customer_finance_account_id}`, {
          params: {
            with: "sales_invoice",
            remaining_receivable__gt: 0,
            customer_id__eq: this.value.id,
            with_sub_product: true
          }
        })
        .then(response => {
          const { data } = response.data;
          this.$set(this, "model", {
            ...data
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    update() {
      return this.$axios.put(`/customer_finance_accounts/${this.value.customer_finance_account_id}`, {
        description: this.model.description
      });
    },
    updated(value) {
      this.editing = false;
      return Promise.resolve(value);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/design/app";
.table-model {
  @extend .jds-table;
  table {
    @extend .table-zebra;
    @extend .table-borderless;
  }
  overflow: auto;
}
</style>
